import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { globalGetApiUrl } from "../../utils/globalBaseUrl";
import { captureException } from "@sentry/react";
import LocalStorageService from "../../core/services/local-storage.service";

const localStorageService = LocalStorageService.getService();

const profileEndpoint = globalGetApiUrl("auth/getUserProfileComplete");

export const fetchUserProfile = createAsyncThunk("user/fetchProfile", async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get(profileEndpoint);
    const profile = response.data;

    const localStorageUserDetails = {
      full_name: profile.fullName,
      active_status: profile.isActive,
      email_address: profile.email,
      is_salesforce_active: profile.is_salesforce_active,
      is_hubspot_active: profile.is_hubspot_active,
      is_zoho_active: profile.is_zoho_active,
    };
    localStorage.setItem("userId", profile.userId);
    localStorage.setItem("orgId", profile.organisationId);
    localStorage.setItem("isInternalAdmin", profile.isInternalAdmin);
    localStorage.setItem("isInternalUser", profile.isInternalUser);
    localStorage.setItem("isAdmin", profile.isAdmin);
    localStorage.setItem("productArr", profile.productArr);
    localStorage.setItem("email_address", profile.email);
    localStorageService.setDataToLocalStorage("userDetails", localStorageUserDetails);
    return profile;
  } catch (err) {
    captureException(err);
    return rejectWithValue(err.message);
  }
});

const initialState = {
  profile: {
    userId: "",
    organisationId: "",
    fullName: "",
    email: "",
    isActive: false,
    isInternalAdmin: false,
    isInternalUser: false,
    isAdmin: false,
    is_salesforce_active: false,
    is_hubspot_active: false,
    is_zoho_active: false,
    productArr: [],
  },
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
      state.profile = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setUserProfile } = userSlice.actions;
export default userSlice.reducer;
